/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable-line react/forbid-prop-types */
import React from "react"
import Head from "next/head"
import Layout from "components/Layout"
import TextPage from "components/Mobile/TextPage"
import Link from "next/link"
import { Avatar, Box, Button, Card } from "@material-ui/core"
import { theme } from "theme"
import { imageSrcHelper } from "settings"

import AccessTimeIcon from "@material-ui/icons/AccessTime"
import moment from "moment"
import "moment/locale/it"

const ForumPage = ({ threadData }) => {
  return (
    <Layout>
      <Head>
        <title>Forum</title>
      </Head>
      <TextPage
        pageTitle="Forum"
        pageContent={
          <Box>
            {/* <Typography variant="h5" display="block" paragraph style={{ fontWeight: "bold", color: "grey" }}>
            Argomenti
          </Typography> */}
            {threadData.map((thread) => (
              <Link href={`/forum/${thread.slug}`} key={thread.slug}>
                <Card
                  style={{
                    margin: theme.spacing(1),
                    marginBottom: theme.spacing(2),
                    padding: theme.spacing(2),
                    cursor: "pointer",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  <>
                    {thread.title}
                    <Box mr={1} display="flex" alignItems="center" fontWeight="normal">
                      {thread.user !== null ? (
                        <Box mt={1} mr={1} display="flex" alignItems="center">
                          <Avatar
                            style={{
                              fontSize: "12px",
                              width: theme.spacing(3),
                              height: theme.spacing(3),
                              marginRight: theme.spacing(1),
                            }}
                            src={imageSrcHelper(thread.user?.avatar, "thumbnail")}
                          >
                            {`${thread.user?.firstname[0] ?? ""}${thread.user?.lastname[0] ?? ""}`.toUpperCase()}
                          </Avatar>
                          <Box>{`${thread.user?.firstname ?? ""} ${thread.user?.lastname[0] ?? ""}.`}</Box>
                        </Box>
                      ) : (
                        `Utente rimosso`
                      )}
                      <Box mt={1} mr={1} display="flex" alignItems="center">
                        <AccessTimeIcon style={{ marginRight: theme.spacing(1), color: "#717171" }} /> Scritto il{" "}
                        {moment(thread.createdAt).format("DD MMM YYYY")}
                      </Box>
                    </Box>
                  </>
                </Card>
              </Link>
            ))}

            <Box mt={3}>
              <Link href="/forum/add">
                <Button type="submit" variant="contained" color="primary">
                  Crea nuovo argomento
                </Button>
              </Link>
            </Box>
          </Box>
        }
      />
    </Layout>
  )
}

export default ForumPage

export async function getStaticProps(context) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/forum-threads`)
  const threadData = await res.json()

  return {
    props: {
      threadData,
    },
    // we will attempt to re-generate the page:
    // - when a request comes in
    // - at most once every second
    revalidate: 1,
  }
}
